// custom cells for the table
import Entity from "./Cells/Entity";
import Error from "./Cells/Error";
import Success from "./Cells/Success";
import Total from "./Cells/Total";
import { EntityData } from "./useGetEntitiesData";

type Col = {
	id: string;
	Cell: (entity: EntityData) => JSX.Element | null;
	label: string;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "entity",
		Cell: Entity,
		label: "overview.name",
		align: "left"
	},
	{
		id: "countReady",
		Cell: Success,
		align: "center",
		label: "overview.success"
	},
	{
		id: "countFailure",
		Cell: Error,
		align: "center",
		label: "overview.error"
	},
	{
		id: "count",
		Cell: Total,
		align: "center",
		label: "overview.total"
	}
];

export default cols;
